/* BEDRA 22.10.2026 – collection page v2: filters, show more, grid toggles, sort */
(function () {
  var root = document.querySelector('[data-bc]');
  if (!root) return;
  var PAGE = 24;
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bc-card]'));
  var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-bc-tile]'));
  var drawer = root.querySelector('[data-bc-drawer]');
  var more = root.querySelector('[data-bc-more]');
  var moreBtn = root.querySelector('[data-bc-morebtn]');
  var showingEl = root.querySelector('[data-bc-showing]');
  var barEl = root.querySelector('[data-bc-bar]');
  var noneEl = root.querySelector('[data-bc-none]');
  var applyBtn = root.querySelector('[data-bc-apply]');
  var fcount = root.querySelector('[data-bc-fcount]');
  var L_SHOW = root.getAttribute('data-l-showing') || '{x} / {y}';
  var L_RES = root.getAttribute('data-l-res') || '{n}';
  var colours = {};
  try { colours = JSON.parse(root.querySelector('[data-bc-colours]').textContent); } catch (e) {}
  var dec = document.createElement('textarea');
  Object.keys(colours).forEach(function (k) { dec.innerHTML = colours[k][0]; colours[k][0] = dec.value; });
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL'];
  var LEN_ORDER = ['mini', 'midi', 'maxi'];
  var state = { size: [], colour: [], len: [], pk: false, r24: false };
  var limit = PAGE;

  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function load(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function list(el, attr) { var v = el.getAttribute(attr) || ''; return v.split('|').filter(Boolean); }

  /* build filter options from the products on the page */
  function collect(attr) {
    var m = {};
    cards.forEach(function (c) { list(c, attr).forEach(function (v) { m[v] = (m[v] || 0) + 1; }); });
    return m;
  }
  function addOpts(group, map, order, labelFn) {
    var box = drawer.querySelector('[data-opts="' + group + '"]');
    var keys = Object.keys(map);
    function norm(k) { return group === 'size' ? k.toUpperCase() : k; }
    if (order) keys.sort(function (a, b) {
      var ia = order.indexOf(norm(a)), ib = order.indexOf(norm(b));
      if (ia === -1) ia = 99;
      if (ib === -1) ib = 99;
      return ia - ib || a.localeCompare(b);
    });
    if (!keys.length) { box.closest('fieldset').hidden = true; return; }
    keys.forEach(function (k) {
      var lab = document.createElement('label'); lab.className = 'bc-opt';
      var inp = document.createElement('input'); inp.type = 'checkbox'; inp.value = k; inp.setAttribute('data-f', group);
      var sp = document.createElement('span');
      labelFn(sp, k);
      var em = document.createElement('em'); em.textContent = map[k]; sp.appendChild(em);
      lab.appendChild(inp); lab.appendChild(sp); box.appendChild(lab);
    });
  }
  addOpts('size', collect('data-sizes'), SIZE_ORDER, function (sp, k) { sp.appendChild(document.createTextNode(k + ' ')); });
  var withCol = cards.filter(function (c) { return list(c, 'data-cols').length; }).length;
  addOpts('colour', withCol >= cards.length * 0.6 ? collect('data-cols') : {}, Object.keys(colours), function (sp, k) {
    var c = colours[k] || [k, '#ccc'];
    var i = document.createElement('i'); i.style.background = c[1]; sp.appendChild(i);
    sp.appendChild(document.createTextNode(c[0] + ' '));
  });
  addOpts('len', collect('data-len'), LEN_ORDER, function (sp, k) { sp.appendChild(document.createTextNode(k.charAt(0).toUpperCase() + k.slice(1) + ' ')); });
  var anyPk = cards.some(function (c) { return c.getAttribute('data-pk') === '1'; });
  var anyR = cards.some(function (c) { return c.getAttribute('data-r24') === '1'; });
  if (!anyPk) { var b1 = root.querySelector('[data-bc-toggle="pk"]'); if (b1) b1.hidden = true; var i1 = drawer.querySelector('input[data-f="pk"]'); if (i1) i1.closest('label').hidden = true; }
  if (!anyR) { var b2 = root.querySelector('[data-bc-toggle="r24"]'); if (b2) b2.hidden = true; var i2 = drawer.querySelector('input[data-f="r24"]'); if (i2) i2.closest('label').hidden = true; }
  ['size', 'colour', 'len'].forEach(function (g) {
    var fs = drawer.querySelector('fieldset[data-g="' + g + '"]');
    var qb = root.querySelector('[data-bc-open="' + g + '"]');
    if (fs && fs.hidden && qb) qb.hidden = true;
  });

  function matches(c, st) {
    if (st.size.length) { var s = list(c, 'data-sizes'); if (!st.size.some(function (v) { return s.indexOf(v) > -1; })) return false; }
    if (st.colour.length) { var co = list(c, 'data-cols'); if (!st.colour.some(function (v) { return co.indexOf(v) > -1; })) return false; }
    if (st.len.length) { var l = list(c, 'data-len'); if (!st.len.some(function (v) { return l.indexOf(v) > -1; })) return false; }
    if (st.pk && c.getAttribute('data-pk') !== '1') return false;
    if (st.r24 && c.getAttribute('data-r24') !== '1') return false;
    return true;
  }
  function active(st) { return st.size.length + st.colour.length + st.len.length + (st.pk ? 1 : 0) + (st.r24 ? 1 : 0); }
  function readDrawer() {
    var st = { size: [], colour: [], len: [], pk: false, r24: false };
    drawer.querySelectorAll('input[data-f]:checked').forEach(function (i) {
      var f = i.getAttribute('data-f');
      if (f === 'pk' || f === 'r24') st[f] = true; else st[f].push(i.value);
    });
    return st;
  }
  function writeDrawer() {
    drawer.querySelectorAll('input[data-f]').forEach(function (i) {
      var f = i.getAttribute('data-f');
      i.checked = (f === 'pk' || f === 'r24') ? !!state[f] : state[f].indexOf(i.value) > -1;
    });
  }
  function previewCount() {
    var st = readDrawer();
    var n = cards.filter(function (c) { return matches(c, st); }).length;
    applyBtn.textContent = L_RES.replace('{n}', n);
  }

  function render() {
    var hits = cards.filter(function (c) { return matches(c, state); });
    var a = active(state);
    cards.forEach(function (c) { c.hidden = true; });
    hits.forEach(function (c, i) { c.hidden = i >= limit; });
    tiles.forEach(function (t) { t.hidden = a > 0; });
    var shown = Math.min(limit, hits.length);
    showingEl.textContent = L_SHOW.replace('{x}', shown).replace('{y}', hits.length);
    barEl.style.width = (hits.length ? Math.round(shown / hits.length * 100) : 0) + '%';
    moreBtn.hidden = shown >= hits.length;
    more.hidden = hits.length === 0;
    noneEl.hidden = hits.length > 0;
    fcount.hidden = a === 0; fcount.textContent = a;
    root.querySelectorAll('[data-bc-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', state[b.getAttribute('data-bc-toggle')] ? 'true' : 'false'); });
    ['size', 'colour', 'len'].forEach(function (g) {
      var qb = root.querySelector('[data-bc-open="' + g + '"]');
      if (qb) qb.classList.toggle('is-on', state[g].length > 0);
    });
    try {
      var p = new URLSearchParams(location.search);
      ['size', 'colour', 'len'].forEach(function (g) { if (state[g].length) p.set('bc_' + g, state[g].join(',')); else p.delete('bc_' + g); });
      ['pk', 'r24'].forEach(function (g) { if (state[g]) p.set('bc_' + g, '1'); else p.delete('bc_' + g); });
      var q = p.toString();
      history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
    } catch (e) {}
  }

  /* restore filters from the URL */
  try {
    var p0 = new URLSearchParams(location.search);
    ['size', 'colour', 'len'].forEach(function (g) { var v = p0.get('bc_' + g); if (v) state[g] = v.split(','); });
    state.pk = p0.get('bc_pk') === '1'; state.r24 = p0.get('bc_r24') === '1';
  } catch (e) {}

  /* drawer */
  var lastFocus = null;
  function openDrawer(group) {
    writeDrawer(); previewCount();
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var target = group && group !== 'all' ? drawer.querySelector('fieldset[data-g="' + group + '"]') : null;
    var first = (target || drawer).querySelector('input:not([hidden])') || drawer.querySelector('button');
    if (target) target.scrollIntoView({ block: 'start' });
    if (first) first.focus({ preventScroll: !!target });
  }
  function closeDrawer() {
    drawer.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  root.querySelectorAll('[data-bc-open]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(b.getAttribute('data-bc-open')); }); });
  drawer.addEventListener('change', previewCount);
  drawer.querySelectorAll('[data-bc-close]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.hasAttribute('data-bc-apply')) { state = readDrawer(); limit = PAGE; render(); }
      closeDrawer();
    });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });
  root.querySelectorAll('[data-bc-clear]').forEach(function (b) {
    b.addEventListener('click', function () {
      state = { size: [], colour: [], len: [], pk: false, r24: false };
      writeDrawer(); previewCount(); limit = PAGE; render();
    });
  });
  root.querySelectorAll('[data-bc-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { var k = b.getAttribute('data-bc-toggle'); state[k] = !state[k]; limit = PAGE; render(); });
  });
  moreBtn.addEventListener('click', function () { limit += PAGE; render(); });

  /* sort (server side, keeps filters) */
  var sortSel = root.querySelector('[data-bc-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var p = new URLSearchParams(location.search); p.set('sort_by', sortSel.value); p.delete('page');
    location.search = p.toString();
  });

  /* products per row */
  function setCols(attr, v, key) {
    root.setAttribute(attr, v); store(key, v);
    root.querySelectorAll('[' + attr.replace('data-', 'data-bc-') + ']').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute(attr.replace('data-', 'data-bc-')) === String(v)); });
  }
  setCols('data-cols', load('bedra_cols') || '4', 'bedra_cols');
  setCols('data-mcols', load('bedra_mcols') || '2', 'bedra_mcols');
  root.querySelectorAll('[data-bc-cols]').forEach(function (b) { b.addEventListener('click', function () { setCols('data-cols', b.getAttribute('data-bc-cols'), 'bedra_cols'); }); });
  root.querySelectorAll('[data-bc-mcols]').forEach(function (b) { b.addEventListener('click', function () { setCols('data-mcols', b.getAttribute('data-bc-mcols'), 'bedra_mcols'); }); });

  render();
})();
